import { datadogRum } from '@datadog/browser-rum';

const getEnvironment = () => {
    if (window.PRODUCTION) return 'prod';
    if (window.STAGING) return 'stage';

    return 'development';
};

export const initDatadogClient = (buildVersion) =>
    datadogRum.init({
        applicationId: 'ace55866-e9e9-41aa-9b70-7036a2b250e2',
        clientToken: 'pube62ff53cea731aa191483bf2c93eb7d8',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.com',
        service: 'perpay-web',
        env: getEnvironment(),
        // Specify a version number to identify the deployed version of your application in Datadog
        version: buildVersion,
        // Increasing these two sample rates can have a large impact on cost.
        // Please consider carefully and discuss with a Datadog admin if needed.
        sessionSampleRate: 5,
        // sessionReplaySampleRate is a percentage of sessionSampleRate above
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
    });
